import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BranchComparePage } from '@/features/branch-insights/pages/branch-compare-page';

const day = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/** Enterprise branch comparison; the date range lives in the URL (default: this month). */
export const Route = createFileRoute('/_app/branch-compare')({
  validateSearch: z.object({
    from: day.optional().catch(undefined),
    to: day.optional().catch(undefined),
  }),
  component: BranchComparePage,
});
